import { render, staticRenderFns } from "./AntiCartonForeign.vue?vue&type=template&id=749d956c&scoped=true&"
import script from "./AntiCartonForeign.vue?vue&type=script&lang=js&"
export * from "./AntiCartonForeign.vue?vue&type=script&lang=js&"
import style0 from "./AntiCartonForeign.vue?vue&type=style&index=0&id=749d956c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d956c",
  null
  
)

export default component.exports